import "../App.css";
import "./HomeCard.css";
import React, { useState } from "react";

function HomeCard({ app, index }) {
  return (
    <div key={index} className="homecard-container">
      <div className="homecard-image-wrap">
        <img
          src={app.banner}
          alt={`${app.name} screenshot`}
          className="homecard-banner"
          style={{ objectPosition: app.id === "sevn" ? "25%" : "center" }}
        />
        <img
          src={app.iconList}
          alt={`${app.name} icon`}
          className="homecard-icon"
        />
      </div>

      <div className="homecard-content">
        <h2 className="homecard-title">{app.name}</h2>
        <p className="homecard-desc">{app.shortDescription}</p>

        <div className="homecard-actions">
          <div className="homecard-stores">
            <a
              href={app.appStoreLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/9/91/Download_on_the_App_Store_RGB_blk.svg"
                alt="Download on the App Store"
                className="homecard-store-img"
              />
            </a>

            <a
              href={app.playStoreLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                className="homecard-store-img"
              />
            </a>
          </div>

          <a href={app.link} className="homecard-btn-primary">
            Learn More
          </a>

          <div className="homecard-links">
            <a href={app.privacyLink} className="homecard-link">
              Privacy Policy
            </a>
            <a href={app.termsLink} className="homecard-link">
              Terms
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeCard;
